export const AvisosPrivacidadJS = [
    {
        "nombre" : "Procuraduría de Protección de Niñas, Niños, Adolescentes y la Familia del Estado de Hidalgo",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/01_AP_PROCURADURIA.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Actopan",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/02_AP_SUB_ACTOPAN.pdf"
    },
    {        
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Apan",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/03_AP_SUB_APAN.pdf"
    },
    {          
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Atotonilco el Grande",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/04_AP_SUB_ATOTONILCO.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito del Distrito Judicial de Huejutla de Reyes",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/05_AP_SUBHUEJUTLA.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Huichapan",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/06_AP_SUB_HUICHAPAN.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Ixmiquilpan",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/07_AP_SUB_IXMIQUILPAN.pdf"
     },
     {       
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Jacala de Ledezma",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/08_AP_SUB_JACALA.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Metztitlan",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/09_AP_SUB_METZTITLAN.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Mixquiahuala de Juárez",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/10_AP_SUB_MIXQUIAHUALA.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Molango de Escamilla",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/11AP_SUB_MOLANGO.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Tenango de Doria",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/12_AP_SUB_TENANGO.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Tizayuca",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/13_AP_SUB_TIZAYUCA.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Tula de Allende",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/14_AP_SUBP_TULA.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Tulancingo de Bravo",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/15_AP_SUBP_TULANCINGO.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Zacualtipán de Ángeles",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/16_AP_SUBP_ZACUALTIPAN.pdf"
    },
    {
        "nombre" : "Subprocuraduría Regional de Protección de Niñas, Niños, Adolescentes y la Familia del Distrito Judicial de Zimapán",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/17_AP_SUBP_ZIMAPAN.pdf"
    },
    {
        "nombre" : "Incidencias de Personal del Sistema DIF Hidalgo",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Incidencias_Personal.pdf"
    },
    {
        "nombre" : "Espacios de Alimentación Encuentro y Desarrollo (EAEyD)",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Sub_Programas_Alimentarios.pdf"
    },
    {
        "nombre" : "Departamento de Trabajo Social y Recepción del Hospital del Niño DIF",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AVISO_DE_PRIVACIDAD_TS_HNDH_2024.pdf"
    },
    {
        "nombre" : "Departamento de Recursos Humano del Hospital del Niño DIF",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AVISO_DE_PRIVACIDAD_RH_HNDH_2024.pdf"  
    },
    {
        "nombre" : "Unidad Institucional para la Igualdad entre Mujeres y Hombres",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/Unidad_Institucional_para_la_Igualdad_entre_Mujeres_y_Hombres.pdf"  
    },
    {
        "nombre" : "Alimentación Escolar Modalidad Caliente",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Alimentacion_Escolar_Modalidad_Caliente.pdf"  
    },
    {
        "nombre" : "Alimentación Escolar Modalidad Fría",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Alimentacion_Escolar_Modalidad_Fria.pdf"  
    },
    {
        "nombre" : "Atención Médica y Terapéutica (CRIH)",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Atencion_Medica_y_Terapeutica_CRIH.pdf"  
    },
    {
        "nombre" : "Apoyo y Bienestar",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Apoyo_Y_Bienestar.pdf"  
    },
    {
        "nombre" : "Ayudas Técnicas",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Ayudas_Tecnicas.pdf"  
    },
    {
        "nombre" : "DIF Contigo",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_DIF_Contigo.pdf"  
    },
    {
        "nombre" : "Atención Alimentaria a Grupos Prioritarios, Adultos Mayores",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Atencion_Alimentaria_a_Grupos_Prioritarios_Adultos_Mayores.pdf"  
    },
    {
        "nombre" : "Atención Alimentaria a Grupos Prioritarios, Personas con Discapacidad",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Atencion_Alimentaria_a_Grupos_Prioritarios_Personas_con_Discapacidad.pdf"  
    },
    {
        "nombre" : "Atención Alimentaria a Personas en Situación de Emergencia o Desastre",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Atencion_Alimentaria_a_Personas_en_Situacion_de_Emergencia_o_Desastre.pdf"  
    },
    {
        "nombre" : "Atención Alimentaria en los Primeros 1000 Días de Vida",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Atencion_Alimentaria_en_los_Primeros_1000_Dias_de_Vida.pdf"  
    },
    {
        "nombre" : "Programa Salud y Bienestar Comunitario",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Programa_Salud_y_Bienestar_Comunitario.pdf"  
    },
    {
        "nombre" : "Jornadas Médicas de Subespecialidad",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Jornadas_Medicas_de_Subespecialidad.pdf"  
    },
    {
        "nombre" : "Hacia una vida mejor” Centro de Rehabilitación Integral Hidalgo",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Hacia_una_vida_mejor.pdf"  
    },
    {
        "nombre" : "Casa de las y los Adolescentes",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Casa_de_las_y_los_Adolescentes.pdf"  
    },
    {
        "nombre" : "Centro de Asistencia Social Casa del Niño",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Centro_de_Asistencia_Social_Casa_del_Niño.pdf"  
    },
    {
        "nombre" : "Centro de Asistencia Social Casa Cuna",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Centro_de_Asistencia_Social_Casa_Cuna.pdf"  
    },
    {
        "nombre" : "Subdirección de Desarrollo de Habilidades en Niñas, Niños y Adolescentes",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Subdireccion_de_Desarrollo_de_Habilidades_en_Niñas_Niños_y_Adolescentes.pdf"  
    },
    {
        "nombre" : "Centro de Asistencia Social Casa de la Niña",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Casa_de_la_Niña.pdf"  
    },
    {
        "nombre" : "Centro de Asistencia Social Casa de la Adolescente",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Casa_de_la_Adolescente_X.pdf"  
    },
    {
        "nombre" : "Centro de Atención Infantil CAI",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_CAI.pdf"  
    },
    {
        "nombre" : "Centro de Atención Infantil CAI Atorón",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_CAI_Atoron.pdf"  
    },
    {
        "nombre" : " Centro de Atención Infantil CAI Bomberos",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_CAI_Bomberos.pdf"  
    },
    {
        "nombre" : "Centro de Atención Infantil CAI Burócratas",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_CAI_Burocratas.pdf"  
    },
    {
        "nombre" : "Centro de Atención Infantil CAI Matilde",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_CAI_Matilde.pdf"  
    },
    {
        "nombre" : "Centro de Atención Infantil CAI San Bartolo",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_CAI_San_Bartolo.pdf"  
    },
    {
        "nombre" : "Centro de Atención Infantil CAI Venta",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_CAI_Venta_Prieta.pdf"  
    },
    {
        "nombre" : "Subdirección de Enseñanza e Investigación",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Subdireccion_Enseñanza_Investigacion.pdf"  
    },
    {
        "nombre" : "Subdirección de Modelos de Atención y Certificación de Competencias",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Subdireccion_Modelos_de_Atencion_y_Certificacion_de_Competencias.pdf" 
    },
    {
        "nombre" : "Departamento de Atención a usuarios, Dirección de Informática",
        "linkAviso" : "http://dif.hidalgo.gob.mx/pdf/AvisosPrivacidad/AP_Direccion_de_Informatica_Atencion_a_usuarios.pdf" 
    }
]